import { API_URL } from '../constants';
import { apiRequest, apiRequestFormData } from '../utils/api';

export interface SingleUploadResponse {
  message: string;
  file: {
    key: string;
    filename: string;
    originalName: string;
    mimetype: string;
    size: number;
    url: string;
    publicUrl: string;
  };
}

export interface MultipleUploadResponse {
  message: string;
  files: {
    key: string;
    filename: string;
    originalName: string;
    mimetype: string;
    size: number;
    url: string;
    publicUrl: string;
  }[];
}

export interface PostUploadResponse {
  message: string;
  file: {
    key: string;
    filename: string;
    originalName: string;
    mimetype: string;
    size: number;
    url: string;
    publicUrl: string;
    walletAddress: string;
    postId: string;
  };
}

export interface PostMultipleUploadResponse {
  message: string;
  files: {
    key: string;
    filename: string;
    originalName: string;
    mimetype: string;
    size: number;
    url: string;
    publicUrl: string;
  }[];
  walletAddress: string;
  postId: string;
}

class UploadService {
  private baseUrl = API_URL + '/api/upload';

  async uploadSingle(file: File): Promise<SingleUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);

    return apiRequestFormData(`${this.baseUrl}/single`, {
      method: 'POST',
      body: formData,
    });
  }

  async uploadMultiple(files: File[]): Promise<MultipleUploadResponse> {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });

    return apiRequestFormData(`${this.baseUrl}/multiple`, {
      method: 'POST',
      body: formData,
    });
  }

  async deleteFile(key: string): Promise<void> {
    await apiRequest(`${this.baseUrl}/${key}`, {
      method: 'DELETE',
    });
  }

  async getFileInfo(key: string): Promise<any> {
    return apiRequest(`${this.baseUrl}/${key}/info`);
  }

  async getSignedUrl(key: string): Promise<{ url: string }> {
    return apiRequest(`${this.baseUrl}/${key}/signed-url`);
  }

  async uploadPostFile(file: File, walletAddress: string, postId: string): Promise<PostUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const url = `${this.baseUrl}/post/single?walletAddress=${encodeURIComponent(walletAddress)}&postId=${encodeURIComponent(postId)}`;

    return apiRequestFormData(url, {
      method: 'POST',
      body: formData,
    });
  }

  async uploadPostFiles(files: File[], walletAddress: string, postId: string): Promise<PostMultipleUploadResponse> {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });

    const url = `${this.baseUrl}/post/multiple?walletAddress=${encodeURIComponent(walletAddress)}&postId=${encodeURIComponent(postId)}`;

    return apiRequestFormData(url, {
      method: 'POST',
      body: formData,
    });
  }

  async uploadProfileImage(file: File, walletAddress: string): Promise<SingleUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);

    const url = `${this.baseUrl}/profile?walletAddress=${encodeURIComponent(walletAddress)}`;

    return apiRequestFormData(url, {
      method: 'POST',
      body: formData,
    });
  }
}

const uploadService = new UploadService();
export default uploadService;
